import { tokens } from '@fluentui/react-components';

export const colors = {
  primary: tokens.colorPalettePurpleBorderActive,
  white: tokens.colorNeutralForegroundInvertedLink,
  black: tokens.colorNeutralForeground3Hover,
  red: tokens.colorPaletteRedBackground2,
  lightGrey: tokens.colorNeutralStroke1,
};
